import Cookies from 'js-cookie';

import { COOKIES } from '@libs/core';

import { getDecisions } from './parseDecisions';

/**
 * Client-only Auth0 feature-flag check via the `x-petm-decisions` cookie.
 *
 * Must only be called from client-side code (e.g. event handlers, effects).
 * Do not use on the server, and do not use to conditionally render components —
 * for component renders use `useDecisions('auth0')` instead so Optimizely
 * impressions are recorded.
 */
export function isAuth0Enabled(): boolean {
    return getDecisions({ raw: Cookies.get(COOKIES.X_PETM_DECISIONS) }).auth0 === true;
}
